import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { isDateValid } from '@makyoapp/makyo-common'
import { DateTimeInput } from '@makyoapp/makyo-tw-ui'

/**
 * FilterDateRangeField
 */
export function FilterDateRangeField({
  start: startDate,
  end: endDate,
  onChange,
}: {
  start?: Date
  end?: Date
  onChange: (start?: string, end?: string) => void
}) {
  const { t } = useTranslation()
  const [start, setStart] = useState<string | null>(startDate ? startDate.toISOString() : null)
  const [end, setEnd] = useState<string | null>(endDate ? endDate.toISOString() : null)

  useEffect(() => {
    if (start && end) {
      onChange?.(start, end)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [start, end])

  const minDate = new Date()
  minDate.setFullYear(minDate.getFullYear() - 100)

  return (
    <div className='flex flex-col sm:flex-row sm:items-center gap-4'>
      <DateTimeInput
        value={start && isDateValid(new Date(start)) ? start : null}
        className='w-full'
        minDate={minDate}
        label={t('Start Date')}
        onChange={(value) => setStart(value)}
      />
      <DateTimeInput
        value={end && isDateValid(new Date(end)) ? end : null}
        className='w-full'
        minDate={minDate}
        label={t('End Date')}
        onChange={(value) => setEnd(value)}
      />
    </div>
  )
}
